module.exports = __webpack_public_path__ + "img/TFT_app-icon-rounded.25ea2b86.jpg";